import api from './api';

export function findAll() {
  return api.get('/doencas-preexistentes');
}

export function save(values) {
  return api.post('/doencas-preexistentes', values);
}
